import { useCreateSubmission } from '@hooks/mutations/ledger/useSubmission';
import { AppRewardConfiguration } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Configuration/AppReward';
import {
  ERR_CREATE_APP_REWARD_CONFIG,
  SUC_CREATE_APP_REWARD_CONFIG,
} from '../../../../utils/strings';

export const useCreateAppRewardConfiguration = () => {
  const { submit } = useCreateSubmission(
    AppRewardConfiguration,
    SUC_CREATE_APP_REWARD_CONFIG,
    ERR_CREATE_APP_REWARD_CONFIG,
  );
  return submit;
};
